module.exports = __webpack_public_path__ + "img/05-SiteQuiz-02.6e4a2f91.png";